import { ProductType } from '../../services/quote.interfaces';

export const getDataLayerQuoteFunnerJourney = (
  productType: ProductType | null
): string => {
  switch (productType) {
    case 'buying':
      return 'Buying a home';
    case 'selling':
      return 'Selling a home';
    case 'buying-and-selling':
      return 'Buying and selling a home';
    case 'remortgaging':
      return 'Remortgaging a home';
    default:
      return 'buying';
  }
};
